<template>
	<div id="global-header">
		<div class="content">
			<div class="global-nav" role="navigation" :aria-label=labels.primary>
				<div class="container-liquid-parent">
					<div class="container-liquid">
						<div class="all-sites-mobile-nav hidden-sm hidden-md hidden-lg">
							<div>
								<ul class="top-menu">
									<li class="main-link" v-if="showLanguageOption">
										<a @click="showLangChooser=true">
											<span class="icon icon-about invisible" aria-hidden="true"></span>
											<span class="">{{ labels.chooseLanguage }}</span>
										</a>
									</li>
									<li class="main-link">
										<a :href=labels.allgysites.allref target="_blank">
											<span class="icon icon-about" aria-hidden="true"></span>
											<span>{{ labels.allgysites.alllabel }}</span>
										</a>
									</li>
								</ul>
							</div>
						</div>
						<div class="all-sites-nav" v-show="IsAuthorized">
							<div class="container">
								<div class="navbar-user">
									{{ HeaderMenuItems ? HeaderMenuItems.full_name : '' }} | {{ HeaderMenuItems ? HeaderMenuItems.user_name : '' }}
								</div>
								<ul class="top-menu">
									<li class="main-link" v-if="showLanguageOption">
										<a class="clickMe" @click="showLangChooser=true">
											<span class="icon icon-about invisible" aria-hidden="true"></span>
											<span class="">{{ labels.chooseLanguage }}</span>
										</a>
									</li>
									<li class="main-link">
										<a :href=labels.allgysites.allref target="_blank" class="clickMe">
											<span class="icon icon-about" aria-hidden="true"></span>
											<span>{{ labels.allgysites.alllabel }}</span>
										</a>
									</li>
									
									<li class="main-link">
										<router-link class="dropdown-toggle" :to="{ name: 'Logout' }">
											<span class="glyphicon glyphicon-log-out" aria-hidden="true"></span>
											<span class="menu-item-text">{{ $trans(labels.login.logoutLabel) }}</span>
										</router-link>
									</li>
								</ul>
							</div>
						</div>
						<div class="all-sites-nav" v-show="!IsAuthorized">
							<div class="container">
								<ul class="top-menu">
									
									<li class="main-link" v-if="showLanguageOption">
										<a class="clickMe" @click="showLangChooser=true">
											<span class="icon icon-about invisible" aria-hidden="true"></span>
											<span class="">{{ $trans(labels.chooseLanguage) }}</span>
										</a>
									</li>
									<li class="main-link">
										<a :href=labels.allgysites.allref target="_blank">
											<span class="icon icon-about" aria-hidden="true"></span>
											<span>{{ $trans(labels.allgysites.alllabel) }}</span>
										</a>
									</li>
									<li class="main-link">
										<router-link class="dropdown-toggle" :to="{ name: 'Login' }">
											<span class="glyphicon icon icon-gy-lock" aria-hidden="true"></span>
											<span>{{ $trans(labels.login.loginLabel) }}</span>
										</router-link>
										
									</li>
								</ul>
							</div>
						</div>
						<nav class="navbar">
							<div class="container">
								<div class="navbar-header">
									<a class="navbar-brand" v-on:click="home" :aria-label=labels.gyhomepage.gyhomepageLabel>
										<img src="data:image/png;base64, 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" alt="Goodyear Fleet Central">
									</a>
									<button type="button" class="navbar-toggle visible-xs" data-toggle="collapse" :aria-label=labels.mobileNav @click="collapseMobileMenu">
										<span class="icon-bar"></span>
										<span class="icon-bar"></span>
										<span class="icon-bar"></span>
									</button>
								</div>
								<!-- Mobile  -->
								<div class="js-navbar-collapse desktop" :class="isCollapseMobileMenu ? 'collapse in' : 'collapse'">
									<ul class="nav navbar-nav" v-if="HeaderMenuItems && HeaderMenuItems !== undefined">
										<li class="dropdown-large user">
											<a class="dropdown-toggle disabled">{{ HeaderMenuItems ? HeaderMenuItems.full_name : '' }} ({{ HeaderMenuItems ? HeaderMenuItems.user_name : '' }})</a>
										</li>
										<li class="dropdown-large">
											<a class="dropdown-toggle" v-on:click="home">{{ $trans('Home') }}</a>
										</li>
										<li class="dropdown-large"
											v-for="tab in HeaderMenuItems.tabs" 
											:key="tab.key" 
											@click="toggleMobileMenu(tab)"
											
											>
											<a
											>{{ $trans(tab.name) }}</a>
											<span v-if="tab.isCollapsed == true" class="visible-xs icon-thin-arrow-right" ></span>
											<span v-else-if="tab.isCollapsed == false" class="visible-xs icon-thin-arrow-down"></span>
											<ul
												class="service-collapse" :class="tab.id==menuDropDowned ? 'collapse in' : 'collapse'">
												<li v-for="menuitem in tab.links" :key="menuitem.key">
													<a @click="followLink" v-bind:href="replaceLink(menuitem.url)" :sso-id="menuitem.sso_id" class="mobile-sub-menu clickMe">
														{{ $trans(menuitem.name) }}
													</a>
												</li>
											</ul>
										</li>
										<li class="dropdown-large" v-show="IsAuthorized" v-on:click="allclose()">
											<a v-bind:href="HeaderMenuItems.my_info" class="dropdown-toggle">{{ $trans(HeaderMenuItems.my_info_name) }}</a>
										</li> 
										<li class="dropdown-large" v-show="!IsAuthorized">
											<router-link :to="{ name: 'Login' }">{{ $trans(labels.login.loginLabel) }}</router-link>
											<span class="glyphicon icon icon-gy-lock" aria-hidden="true"></span>											
										</li>
										<li class="dropdown-large" v-show="IsAuthorized">
											<router-link :to="{ name: 'Logout' }">{{ $trans(labels.login.logoutLabel) }}</router-link>
											<span class="glyphicon glyphicon-log-out"></span>
										</li>
									</ul>
									<ul class="nav navbar-nav" v-else>
										<li class="dropdown-large user">
											<a class="dropdown-toggle disabled">{{ HeaderMenuItems ? HeaderMenuItems.full_name : '' }} ({{ HeaderMenuItems ? HeaderMenuItems.user_name : '' }})</a>
										</li>
										<li class="dropdown-large">
											<a class="dropdown-toggle" v-on:click="home">{{ $trans('Home') }}</a>
										</li>
										<li class="dropdown-large" v-show="!IsAuthorized">
											<router-link :to="{ name: 'Login' }">{{ $trans(labels.login.loginLabel) }}</router-link>
											<span class="glyphicon icon icon-gy-lock" aria-hidden="true"></span>											
										</li>
										<li class="dropdown-large" v-show="IsAuthorized">
											<router-link :to="{ name: 'Logout' }">{{ $trans(labels.login.logoutLabel) }}</router-link>
											<span class="glyphicon glyphicon-log-out"></span>
										</li>
									</ul>
								</div>
								<!--  -->
								<div class="collapse navbar-collapse hidden-xs desktop">
									<ul class="nav navbar-nav" v-if="HeaderMenuItems && HeaderMenuItems.tabs" > 
											<li class="dropdown-large" v-on:click="allclose()" v-if="HeaderMenuItems && HeaderMenuItems.home_name">
												<a class="dropdown-toggle" v-on:click="home" >{{ $trans('Home') }}</a>
											</li>

											<li class="dropdown-large" v-for="tab in HeaderMenuItems.tabs" :key="tab.key" v-on:click="toggle(tab.id)" >
												<a class="dropdown-toggle">{{ $trans(tab.name) }}</a> 
												<div class="arrow-up" :style="{ 'display': dropDowned==tab.id ? 'block' : 'none'}" ></div>
											</li>	
											<li class="dropdown-large" v-on:click="allclose()" v-if="HeaderMenuItems && HeaderMenuItems.my_info_name">
												<a v-bind:href="HeaderMenuItems.my_info" class="dropdown-toggle">{{ $trans(HeaderMenuItems.my_info_name) }}</a>
											</li> 	
									</ul>
									<ul class="nav navbar-nav" v-else > 
										<li class="dropdown-large" v-on:click="allclose()" >
											<router-link class="dropdown-toggle" :to="{ name: 'Login' }">{{ $trans('Home') }}</router-link>
										</li>
									</ul>													
								</div>
							</div> <!-- end .main-nav -->
						</nav> <!-- end .navbar -->
					</div> <!-- end .container-liquid -->
					<div class="subMenu" v-if="HeaderMenuItems && HeaderMenuItems.tabs !== undefined">
						<transition 
							mode="in-out"
							v-on:before-enter="transitionBeforeEnter"
							v-on:enter="transitionEnter"
							v-on:leave="transitionLeave"
							v-on:after-leave="transitionAfterLeave"
							
							v-bind:css="false"
							v-for="tab in HeaderMenuItems.tabs" :key="tab.key">
							<div class="dropdown-menu-large" v-if="dropDowned==tab.id" :style="{ 'display': dropDowned==tab.id ? 'block' : 'none'}">
								<div class="row">
									<div class="col-sm-4 col-md-3">
										<div class="dropdown-action">
										</div>
									</div>
									<div class="col-sm-8 col-md-9 dropdown-list-items">
										<ul class="row">
											<li 
												v-for="menuitem in tab.links" :key="menuitem.key"
												class="submenu-col col-sm-11 col-md-6 col-lg-4"
											>
												<a v-bind:href="replaceLink(menuitem.url)" @click="followLink" :sso-id="menuitem.sso_id" v-bind:target="menuitem.new_window==true ? '_blank' : '_self'" class="clickMe">
													<div class="dropdown-tile">
														<p class="dropdown-tile-title">
															{{ $trans(menuitem.name) }}
															<span class="icon-thin-arrow-right"></span>
														</p>
													</div>
												</a>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</transition>
						
						<div class="close-nav-btn hidden-xs" v-on:click="allclose()" :style="{'display': dropDowned!=null ? 'block' : 'none' }"><p>{{ labels.close }}</p></div>
					</div>
				</div>
			</div>
        </div>
		<language-chooser
			@close="showLangChooser=false"
			v-if="showLangChooser"
			>

		</language-chooser>
	</div>
</template>
<script>
	import { mapGetters, mapActions } from "vuex";
	import Velocity from 'velocity-animate';
	import LanguageChooser from '@/components/LanguageChooser.vue';
	import { API_VERIFY_AUTH } from "@/core/services/api/auth.module";
	import { API_TRANSLATIONS_ACTION_LOAD } from "@/core/services/api/translations.module";

	export default {
		name: "header-menu",
		props: ["headers"],
		data() {
			return {
				labels:
				{
					primary: "Primary Site Navigation",
					chooseLanguage: 'Choose Language',
					allgysites: {
						allref: "https://www.goodyear.com/en-US/other-goodyear-sites",
						alllabel: "All Goodyear Sites"
					},
					login:{
						loginRef: "/Membership/Login",
						loginLabel: "Login",
						logoutRef: "/Membership/Logout",
						logoutLabel: "Log Out"
					},
					gyhomepage:{
						gyhomepageRef: "/",
						gyhomepageLabel: "Back to Goodyear Homepage"
					},
					gyfleet: "Goodyear Fleet Central",
					mobileNav: "Mobile Navigation Toggle",
					close: "CLOSE"
				},
				baseUsrl:"https:localhost:44305",
				dropDowned: null,
				mouseDownLink: null,
				isCollapseMobileMenu: false,
				menuDropDowned: null,
				selectedLanguage: null,
				languages: [
					"en-US"
				],
				envMode: process.env.VUE_APP_ENV_NAME,
				envRegion: process.env.VUE_APP_REGION_NAME,
				showLangChooser: false,
			};
		},
		mounted() {
			//this.selectedLanguage = window.localStorage.getItem("USER_LANGUAGE");
			this.selectedLanguage = this.getTranslationsSelectedLocale;
			this.languages = this.getTranslationsLocales;
		},
		components: {
			'language-chooser': LanguageChooser
		},
		computed: {
			//console: () => console,
			...mapGetters({
                UserState: "AppGetUser",
                IsAuthorized: "AppIsAuthenticated",
                HeaderMenuItems: "AppGetHeaderMenuItems",
				Message: "getTranslationsMessage",
				getTranslationsSelectedLocale: "getTranslationsSelectedLocale",
				getTranslationsLocales: "getTranslationsLocales"
            }),
			showLanguageOption(){
				return this.envRegion !== "NA" ||
					this.envMode !== "production" &&
				    this.envMode !== "test-na" && 
				    this.envMode !== "stage-na";
			}
		},
		methods: {
			home(e) {
				var user = this.UserState;
				console.log(user);
				if (user.Group == "GYR" && window.app.$router.history.current.name != "business-solutions-dashboard") {
					window.app.$router.push({ name: "business-solutions-dashboard" });
					//console.log('user.Group == "GYR"');
					//console.log(user);
					//window.app.$root.$emit('show-notify', 'Help us to translate our service to local language');
				}
				if (user.Group == "SSC" && window.app.$router.history.current.name != "business-solutions-dashboard") {
					window.app.$router.push({ name: "business-solutions-dashboard" });
				}
				if (user.Group == "DLR" && window.app.$router.history.current.name != "dealer-portal-dashboard") {
					window.app.$router.push({ name: "dealer-portal-dashboard" });
				}
				if (user.Group == "WIN" && window.app.$router.history.current.name != "dealer-portal-dashboard") {
					window.app.$router.push({ name: "dealer-portal-dashboard" });
				}
				if (user.Group == "CUS" && window.app.$router.history.current.name != "fleet-central-dashboard") {
					window.app.$router.push({ name: "fleet-central-dashboard" });
				}
			},
			followLink(e) {
				e.preventDefault();
				this.$store.dispatch(API_VERIFY_AUTH)
				.then(() => {
					let followLink= e.target.closest("a");
					let ssoId = followLink.getAttribute('sso-id');
					if (followLink) {
						let url = new URL(followLink.href);
                        var a = document.createElement('a');
						if(ssoId == 1){
							a.href = followLink.href + `?mode=sso&token=${encodeURIComponent(this.UserState.GyToken)}&email=${this.UserState.Email}&source=fleet-central`;
						}
						else {
							if (url.search == "") {
                                a.href = followLink.href + "?user=" + this.UserState.GyToken + "&lang=" + localStorage.getItem('USER_LANGUAGE');
							} else {
                                a.href = followLink.href + "&user=" + this.UserState.GyToken + "&lang=" + localStorage.getItem('USER_LANGUAGE');
							}
						}
						a.target = followLink.target;
						document.body.appendChild(a);
	
						a.click();
					}
				})
			},
			transitionBeforeEnter: function (el) {
				
			},
			transitionEnter: function (el, done) {
				Velocity(el, "slideDown", { duration: 600 }, { complete: done });
			},
			transitionLeave: function (el, done) {
				Velocity(el, "slideUp", { duration: 300 }, { complete: done });

			},
			transitionAfterLeave: function (el) {
				
			},
			...mapActions([
                "logout",
				"action_admin_translations_load"
            ]),
			toggle(dropdownName) {
				
				if (this.dropDowned != dropdownName) {
					this.dropDowned = dropdownName;		
				} else {
					this.dropDowned = null;
				}
			},
			toggleMobileMenu(tab) {
				var dropdownName  = tab.id;
				if (this.menuDropDowned != dropdownName) {
					this.menuDropDowned = dropdownName;		
				} else {
					this.menuDropDowned = null;
				}
				if(tab.isCollapsed == true) {
					tab.isCollapsed = false;
				}
				else {
					tab.isCollapsed = true;
				}
			},
			allclose() {
				this.dropDowned = null;
			},
			setLanguage() {
				this.$store.dispatch(API_TRANSLATIONS_ACTION_LOAD, this.selectedLanguage)
				.then(() => {
					this.$i18n.setLocaleMessage(this.selectedLanguage, this.Message);
					this.$i18n.locale = this.selectedLanguage;
					window.localStorage.setItem("USER_LANGUAGE", this.selectedLanguage);
				}).catch(e => {
					console.log(e);
				})
				// location.search = '?lang=' + this.selectedLanguage;
			},
			replaceLink(link) {
				if (process.env.VUE_APP_REPLACE_TARGET) {
                    if (link.includes(process.env.VUE_APP_REPLACE_TARGET)) {
                        return link.replace(process.env.VUE_APP_REPLACE_TARGET, process.env.VUE_APP_REPLACE_DOMEN);
                    }
                }
				if (process.env.VUE_APP_REPLACE_TARGET_TM) {
                    if (link.includes(process.env.VUE_APP_REPLACE_TARGET_TM)) {
                        return link.replace(process.env.VUE_APP_REPLACE_TARGET_TM, process.env.VUE_APP_REPLACE_DOMEN_TM);
                    }
                }
				return link;
			},
			collapseMobileMenu() {
				this.isCollapseMobileMenu = !this.isCollapseMobileMenu;
			}
		},
		created() {
			document.addEventListener('langChooseEvent', (event) => {
				if(localStorage.getItem('USER_LANGUAGE')) {
					this.selectedLanguage = localStorage.getItem('USER_LANGUAGE');
				}
			})
			document.addEventListener('click', this.documentClicked);

		},
		destroyed() {
			document.removeEventListener('click', this.documentClicked);
		}
	};
</script>

<style  scoped>
body .navbar-toggle {
	padding: 0;
	margin-top: 10px;
}
@media only screen and (max-width: 600px) {
	body .navbar-toggle {
		margin: 0;
		padding-top: 15px;
	}
}
@media only screen and (max-width: 767px) {
	.navbar .navbar-header img {
		padding-left: 10px;
		padding-top: 15px;
		padding-bottom: 0;
	}
}
.all-sites-mobile-nav .top-menu li {
	color: #f0f0f0;
	float: left;
	padding: 4px 10px;
	margin: 0;
	font-size: 14px;
}

	.all-sites-mobile-nav .top-menu li.main-link a {
		color: #fd0;
		padding: 0;
		display: inline-block;
		text-decoration: none;
		text-transform: uppercase;
		font-family: BarlowCondensedLight,Arial,sans-serif;
		font-weight: 400;
		font-style: normal;
	}

.all-sites-mobile-nav .top-menu {
	font-weight: normal;
	font-style: normal;
	-webkit-font-smoothing: subpixel-antialiased;
	margin: 4px 0 0;
	padding: 0;
	list-style: none;
	float: right;
	width: auto;
	margin-right: 10px;
}
.all-sites-mobile-nav {
	display: block;
	height: 33px;
	background-color: rgba(0,0,0,.6);
	background-repeat: repeat;
	width: 100%;
	border-bottom: 1px solid rgba(255,255,255,0.2);
	padding: 0;
	margin: 0;
	line-height: 100%;
	overflow-y: hidden;
}
.navbar .container .navbar-header {
	padding-top: 0px;
}
/*.global-nav .navbar-brand {
padding: 0px;
padding-top: 15px;
display: inline-block;
height: auto;
}*/
.global-nav .navbar {
	margin-bottom: 0;
	padding: 0px;
	height: auto;
	min-height: none;
}

.container > .navbar-header {
	margin-right: 0px;
	margin-left: 0px;
}
.dropdown-tile-title {
	white-space: nowrap;
}
.arrow-up {
	width: 0;
	height: 0;
	border-left: 15px solid transparent;
	border-right: 15px solid transparent;
	border-bottom: 15px solid white;
	margin-left: 20px;
}
.slide-leave-active {
	-moz-transition-duration: 0.9s;
	-webkit-transition-duration: 0.9s;
	-o-transition-duration: 0.9s;
	transition-duration: 0.9s;
	-moz-transition-timing-function: ease-in;
	-webkit-transition-timing-function: ease-in;
	-o-transition-timing-function: ease-in;
	transition-timing-function: ease-in;
}

.slide-enter-active {
	-moz-transition-duration: 0.9s;
	-webkit-transition-duration: 0.9s;
	-o-transition-duration: 0.9s;
	transition-duration: 0.9s;
	-moz-transition-timing-function: ease-in;
	-webkit-transition-timing-function: ease-in;
	-o-transition-timing-function: ease-in;
	transition-timing-function: ease-in;
}

.slide-enter, .slide-leave-to {
	max-height: 0;
	overflow: hidden;
	transform: translate3d(0,0%,0);
}

.slide-enter-to, .slide-leave {
	overflow: hidden;
	transform: translate3d(0,-100%,0);
}
</style>
